export default __webpack_public_path__ + "static/media/vanongo_admin_api.58a1e2f4.yaml";